import { render, staticRenderFns } from "./AccountPanel.vue?vue&type=template&id=a4ff236e&scoped=true"
import script from "./AccountPanel.vue?vue&type=script&lang=js"
export * from "./AccountPanel.vue?vue&type=script&lang=js"
import style0 from "./AccountPanel.vue?vue&type=style&index=0&id=a4ff236e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ff236e",
  null
  
)

export default component.exports